import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import Modal from './Modal'
import {Button, Input} from 'antd'

import style from './controls.sass'

@inject('store') @observer
class Controls extends Component {
  state = {
    modal: false
  }
  createAlgo = () => {
    const {selectedTickers, tables} = this.props.store.backtest
    if (selectedTickers.length < tables.pnlByTicker.data.length/2) {
      this.openModal()
    } else {
      this.createStockFilter()
    }
  }
  openModal = () => {
    this.setState({modal:true})
  }
  closeModal = () => {
    this.setState({modal:false})
  }
  createStockFilter = () => {
    this.props.store.backtest.createStockFilter()
  }
  search = (e) => {
    this.props.store.backtest.tables.filterTable(e.target.value)
  }

  render() {
    const {selectedTickers} = this.props.store.backtest
    return(
      <div styleName='wrapper'>
        <Button
          type='default'
          icon='plus'
          onClick={this.createAlgo}
          disabled={!selectedTickers.length}
        >
          Create New Algo
        </Button>
        <Input.Search
          onSearch={this.search}
          styleName='search'
        />
        <Modal
          visible={this.state.modal}
          close={this.closeModal}
          create={this.createStockFilter}
        />
      </div>
    )
  }
}

export default Controls
